(() => {
  if (window.geekoShopifyLanguageBound) return;
  window.geekoShopifyLanguageBound = true;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.geeko-shopify-language')) return;
    form.querySelectorAll('[name="return_to"]').forEach((input) => {
      input.value = location.pathname + location.search;
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.geeko-shopify-language[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.geeko-shopify-language[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
})();
